// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fw-0";